// extracted by mini-css-extract-plugin
module.exports = {"container":"AR","disclaimerIcon":"AS","content":"AT","timeToBeginWatchingText":"AU"};